// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"kC","content":"kD","navigation":"kE","mainPanel":"kF","footer":"kG"};